import { forwardRef, HTMLAttributes, ReactNode } from "react";

import { DownOutlined } from "@ant-design/icons";
import { cx } from "class-variance-authority";

import chevronDownSvg from "../../img/chevron-down.svg";
import { Svg } from "../../utils/svgIcon";

import * as theme from "./ApplicationBarProfile.css";
import {
    ApplicationBarVariant,
    useApplicationBarVariant,
} from "./ApplicationBarVariant";

export interface ApplicationBarProfileProps extends HTMLAttributes<HTMLDivElement> {
    organization: ReactNode;
    /**
     * The signed-in user's name, or a way to sign in.
     */
    user: ReactNode;
    /**
     * Shows that the profile opens a menu. Defaults to `true`.
     */
    chevron?: boolean;
}

// Forwards the ref and props so an antd `Dropdown` can wrap it
export const ApplicationBarProfile = forwardRef<
    HTMLDivElement,
    ApplicationBarProfileProps
>(({ organization, user, chevron = true, className, ...props }, ref) => {
    const variant = useApplicationBarVariant();

    return (
        <div ref={ref} className={cx(theme.profile, className)} {...props}>
            <div className={theme.identification}>
                <span className={theme.organization[variant]}>
                    {organization}
                </span>
                <span className={theme.user[variant]}>{user}</span>
            </div>
            {chevron && chevrons[variant]}
        </div>
    );
});

const chevrons: Record<ApplicationBarVariant, ReactNode> = {
    default: <DownOutlined />,
    flat: <Svg src={chevronDownSvg} className={theme.flatChevron} />,
};
